export const OrganizedExpert = {
  Leader: {
    title: "Creating a party as leader!",
    description:
      "To improve your chance of a successful organized crime you should make sure you have a high Rank XP and submit the most amount of cash possible!",
    assets: "/assets/imgs/xpmarket/magic-hat.png",
  },
  Driver: {
    title: "Driver",
    description:
      "To improve your chance of a successful organized crime you should make sure you have a high race skill, submit the best possible 5 seater car you can!",
    assets: "/assets/imgs/xpmarket/car.png",
  },
  WeaponExpert: {
    title: "Weapons Expert",
    description:
      "To improve your chance of a successful organized crime you should make sure you have good weapons, submit the best weapons & and as many bullets as possible",
    assets: "/assets/imgs/xpmarket/target.png",
  },
  ExplosiveExpert: {
    title: "Explosives Expert",
    description:
      "To improve your chance of a successful organized crime you should make sure you have enough explosives, submit as many alternative weapons as possible",
    assets: "/assets/imgs/organizedcrime/dynamite.png",
  },
  TeamExpert: {
    title: "Team Expert",
    description:
      "To improve your chance of a successful organized crime you should make sure you have a good bodyguard, submit the highest-level bodyguard possible.",
    assets: "/assets/imgs/organizedcrime/teamexpert.png",
  },
};

// Map role names to slot index and expert type
export const roleToSlotMap: Record<string, { slotIndex: number; expertType: typeof OrganizedExpert[keyof typeof OrganizedExpert] }> = {
  Leader: { slotIndex: 0, expertType: OrganizedExpert.Leader },
  Driver: { slotIndex: 1, expertType: OrganizedExpert.Driver },
  Weapon: { slotIndex: 2, expertType: OrganizedExpert.WeaponExpert },
  Explosive: { slotIndex: 3, expertType: OrganizedExpert.ExplosiveExpert },
  Team: { slotIndex: 4, expertType: OrganizedExpert.TeamExpert },
};

export const ROLE_NAMES = ["Leader", "Driver", "Weapon", "Explosive", "Team"] as const;
